// Focus analytics — config + extractor. Inherits the shared engine/dashboard.
//
// No streak metric: the Focus page already shows an engine-canonical streak
// (focus.streak, computeStreak since the foundation PR) in its quick-stats, so
// a streak card would duplicate it. The dashboard adds day/week/month
// aggregation + trend + projection, which the page lacks.
//
// GUARDRAIL: descriptive only — totals/trend, no productivity advice.

import type { Sample } from "./engine";
import type { DashboardConfig } from "./dashboard";
import type { FocusSession } from "@/hooks/useFocus";

export const FOCUS_DASHBOARD: DashboardConfig = {
  moduleKey: "focus",
  titleKey: "focus.analytics.title",
  defaultGranularity: "week",
  metrics: [
    {
      key: "frequency",
      labelKey: "focus.analytics.metric.frequency",
      reducer: "count",
      color: "hsl(187 72% 55%)",
      chart: "bar",
      projectable: true,
    },
    {
      key: "duration",
      labelKey: "focus.analytics.metric.duration",
      reducer: "sum",
      color: "hsl(265 60% 65%)",
      unitKey: "analytics.unit.min",
      chart: "line",
      projectable: true,
    },
  ],
};

export function extractFocusSamples(rows: FocusSession[]): Record<string, Sample[]> {
  const frequency: Sample[] = [];
  const duration: Sample[] = [];

  for (const r of rows) {
    if (!r.completed_at) continue;
    const t = new Date(r.completed_at).getTime();
    if (!Number.isFinite(t)) continue;
    const category = r.mode ?? undefined;

    frequency.push({ t, v: 1, category });
    if (typeof r.duration_minutes === "number" && r.duration_minutes > 0) {
      duration.push({ t, v: r.duration_minutes, category });
    }
  }

  return { frequency, duration };
}
